'use client';

import { useEffect } from 'react';
import { useRollbar } from '@rollbar/react';

import reportErrorDebounced from '@/lib/reportErrorDebounced';

import ErrorMessage from '@/components/ErrorMessage';
import Navbar from '@/components/Navbar';

export default function Error({ error, _reset }: { error: Error; _reset: () => void }) {
  const rollbar = useRollbar();

  useEffect(() => {
    console.error('Error in /[accountId]/folder/error.tsx', error);
    reportErrorDebounced(error, rollbar);
  }, [error, rollbar]);

  return (
    <>
      <Navbar priorPageURL='/' disableSearch={true} />
      <ErrorMessage
        message='Unexpected Error'
        subTitle='Oops! Something went wrong while displaying All Entries Folder'
      />
    </>
  );
}
